import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DistributorsComponent} from './distributors/distributors.component';
import {RouterModule} from '@angular/router';
import {EditDistributorsComponent} from './edit-distributor/edit-distributors.component';
import {ShowDistributorsComponent} from './show-distributors/show-distributors.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {NxSwitcherModule} from "@allianz/ng-aquila/switcher";
import {NxImageModule} from "@allianz/ng-aquila/image";
import {PipeModule} from "../../pipe/pipe.module";


@NgModule({
  declarations: [
    DistributorsComponent,
    EditDistributorsComponent,
    ShowDistributorsComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxCardModule,
        NxIconModule,
        ComponentsModule,
        NxHeadlineModule,
        NxGridModule,
        NxButtonModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxDropdownModule,
        NxSwitcherModule,
        NxImageModule,
        PipeModule,
    ]
})
export class DistributorModule {
}
